/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./swiper-view.vue?vue&type=template&id=e41570ea&scoped=true"
import script from "./swiper-view.vue?vue&type=script&lang=js"
export * from "./swiper-view.vue?vue&type=script&lang=js"
import style0 from "./swiper-view.vue?vue&type=style&index=0&id=e41570ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41570ea",
  null
  
)

export default component.exports